import IState from '@/interfaces/IState';
import router from '@/router';
import { ActionContext } from 'vuex';


export default (context: ActionContext<IState, IState>) => {
    context.commit('clearSession');
    router.push({ name: 'login' });
};
